import script from "./GameHome.vue?vue&type=script&setup=true&lang=js"
export * from "./GameHome.vue?vue&type=script&setup=true&lang=js"

import "./GameHome.vue?vue&type=style&index=0&id=7db76ffc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7db76ffc"]])

export default __exports__